import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.scrollIntoViewIfActive();
    document.addEventListener("turbo:morph", this.scrollIntoViewIfActive);
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.scrollIntoViewIfActive);
  }

  handleClick() {
    const nav = this.element.closest(".templates-nav");
    if (!nav) return;
    nav
      .querySelectorAll("li.custom-template.selected")
      .forEach((el) => el.classList.remove("selected"));
    this.element.closest("li")?.classList.add("selected");
  }

  scrollIntoViewIfActive = () => {
    const item = this.element.closest("li");
    if (!item?.classList.contains("selected")) return;
    item.scrollIntoView({ block: "start", behavior: "instant" });
  };
}
